import { useQuery } from 'react-query';

import type { LlmPricesResponseDto } from '../../../../../backend/src/llm/pricing/dto/llm-pricing.response.dto';
import { QueryEntity } from '../../types';
import useGetFetchConfig from '../../useGetFetchConfig';
import { APIBaseChronos } from '@/api/hosts';

/** Global-admin only. Current price matrix, full version history, and unpriced models. */
export const useFetchLlmPrices = () => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<LlmPricesResponseDto>(
    [QueryEntity.LlmPrices],
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/admin/llm-prices`, fetchConfigGET);
      if (!res.ok) throw new Error('Failed to load LLM prices');
      return (await res.json()) as LlmPricesResponseDto;
    },
    { refetchOnWindowFocus: false },
  );
};
